export default ".full-width {\n  min-width: 15rem;\n}\n\n.flex-container {\n  display: flex;\n}"